<div class="h-screen w-screen flex py-8 md:p-0 md:items-center justify-center">
  <div class="bg-offwhite-100 rounded-xl center w-11/12 md:w-3/4 shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
    <div class="flex flex-col h-full">
      <div class="flex flex-row h-full">
        <div class="flex flex-col jh-full w-full md:w-3/5 p-4 pr-2">
          <img src="/assets/logo.png" class="md:hidden max-h-24 mr-4 mt-4 object-scale-down flex justify-self-start" />

          <div class="flex flex-col justify-center">
            @if (!showThanks) {
              <div class="flex justify-between items-baseline">
                <h1 class="p-4 md:p-8 md:pt-12 pt-16">Show Trial Signup</h1>
                <p class="text-xs pr-8">Step {{showPage1 ? '1' : '2'}} of 2</p>
              </div>
            }

            @if (showPage1) {
              <div class="md:px-8 px-4 pb-4">
                <p class="text-sm">Please complete some details about your organisation and we will create your trial account.</p>
                <label class="block pt-4">
                  <span>Organisation Name <span class="text-danger-base">*</span></span>
                  <input type="text" [(ngModel)]="trialOptions.OrganisationName" (keyup)="page1ValidateUpdate(1)" class="text-box" [ngClass]="{'error': !validators.orgName.valid && orgNameTouched}" />
                </label>
                <label class="block pt-4">
                  <span>Organisation Email <span class="text-danger-base">*</span></span>
                  <input type="email" [(ngModel)]="trialOptions.OrganisationEmail" (keyup)="page1ValidateUpdate(2)" class="text-box" [ngClass]="{'error': !validators.orgEmail.valid && orgEmailTouched}" />
                </label>
                <label class="block pt-4">
                  <span>Organisation Contact Number <span class="text-danger-base">*</span></span>
                  <input type="tel" [(ngModel)]="trialOptions.OrganisationPhone" (keyup)="page1ValidateUpdate(3)" class="text-box" [ngClass]="{'error': !validators.orgNumber.valid && orgNumberTouched}" />
                </label>
                <label class="block pt-4">
                  <span>Organisation Website</span>
                  <input type="text" [(ngModel)]="trialOptions.OrganisationWebsite" (keyup)="page1ValidateUpdate(4)" class="text-box" [ngClass]="{'error': !validators.orgWeb.valid && orgWebTouched}" />
                </label>
                <div class="flex justify-end">
                  <button class="btn-primary mt-6" (click)="page2()">Next ></button>
                </div>
              </div>
            }

            @if (showPage2) {
              <div class="md:px-8 px-4 pb-4">
                <p class="text-sm">To set up your account, please enter your contact details below.</p>
                <label class="block pt-4">
                  <span>Contact Name <span class="text-danger-base">*</span></span>
                  <input type="text" [(ngModel)]="trialOptions.ContactName" (keyup)="page2ValidateUpdate(1)" class="text-box" [ngClass]="{'error': !validators.contactName.valid && contactNameTouched, 'disabled': submitting}" [disabled]="submitting" />
                </label>
                <label class="block pt-4">
                  <span>Contact Email <span class="text-danger-base">*</span></span>
                  <input type="email" [(ngModel)]="trialOptions.ContactEmail" (keyup)="page2ValidateUpdate(2)" class="text-box" [ngClass]="{'error': !validators.contactEmail.valid && contactEmailTouched, 'disabled': submitting}" [disabled]="submitting" />
                </label>
                <div class="flex justify-between">
                  <button class="btn-secondary mt-6 text-sm" (click)="page1()" [disabled]="submitting" [ngClass]="{'disabled': submitting}">< Back</button>
                  <button class="btn-primary mt-6" (click)="createShowTrial()" [disabled]="submitting" [ngClass]="{'disabled': submitting}">
                    @if (!submitting) {
                      <span>Create trial ></span>
                    }
                    @if (submitting) {
                      <span>Processing...</span>
                    }
                  </button>
                </div>
              </div>
            }

            @if (showThanks) {
              <div class="md:px-8 px-4 py-12">
                <p class="text-xl font-bold">Thank you for signing up.</p>
                <p class="pt-4">We've created your Care Audits trial account and sent a password setup email to your contact email address.</p>
                <p class="pt-4">Once set, you'll be able to log in to your account using your email address as the username.</p>
                <p class="pt-4 text-sm text-grey-900">The email should arrive in the next couple of minutes. If you've not received anything after 15 minutes, please check any spam folders and contact us if needed.</p>
                <div class="mt-6">
                  <a href="/login" class="btn-primary md:w-auto text-center">Login ></a>
                </div>
              </div>
            }
          </div>
        </div>
        <div class="flex-col justify-between w-2/5 p-4 pl-2 pb-0 bg-offwhite-500 rounded-xl hidden md:flex">
          <img src="/assets/logo.png" class="p-4 mt-4 center max-h-28 object-scale-down" />
          <img src="/assets/tabletuser.png" class="object-bottom" />
        </div>
      </div>
    </div>
  </div>
</div>
